import { render, staticRenderFns } from "./today-wit.vue?vue&type=template&id=4474aa2a&"
import script from "./today-wit.vue?vue&type=script&lang=js&"
export * from "./today-wit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports